<template>
  <div class="LoginForm d-flex flex-column h-100">
    <h1 class="text-center mb-4 pb-2">Inloggen</h1>
    <div style="min-height: 60px">
      <Feedback :feedback="feedback" />
    </div>
    <Form 
      class="flex-grow-1"
      @submit="handleSubmit">
      <FormField 
        v-model="fields.email.value"
        v-bind="fields.email" />
      <FormField 
        v-model="fields.password.value"
        v-bind="fields.password"
        class="mt-2" />
      
      <button 
        type="submit"
        :disabled='isDisabled'
        class="btn btn-success btn-lg btn-block rounded-pill font-weight-bold border-0 mt-3 p-3">
        Aanmelden
      </button>
    </Form>

    <div class="d-flex justify-content-center mt-5">
      <router-link 
        class="text-muted"
        :to="{ name: 'request-reset' }">
        Wachtwoord vergeten?
      </router-link>
      <span class="d-inline-block mx-3">/</span>
      <router-link 
        class="text-muted" 
        :to="{ name: 'register' }">
        Nieuwe gebruiker?
      </router-link>
    </div>
  </div>
</template>

<script>
import { login, getLastUserEmail, getUser } from 'service/auth'

import { required, email } from 'vuelidate/lib/validators'
import { mapMutations } from 'vuex'

import Feedback from 'atom/Feedback'
import Form from 'molecule/form/Form'
import FormField from 'molecule/form/FormField'

import fields from 'mixin/fields'

export default {
  name: 'LoginForm',
  components: {
    Feedback,
    Form,
    FormField
  },
  mixins: [ fields ],
  data() {
    return {
      feedback: {},
      isDisabled: false,
      fields: {
        email: {
          label: "E-mail",
          autocomplete: "username",
          type: "email",
          placeholder: "naam@bedrijf.nl",
          value: getLastUserEmail(),
          validationRules: {
            required, email
          },
          disabled: false
        },
        password: {
          label: "Wachtwoord",
          autocomplete: "current-password",
          type: "password",
          value: '',
          validationRules: {
            required
          },
          disabled: false
        }
      }
    }
  },
  methods: {
    ...mapMutations('user', [
      'setUser'
    ]),
    handleSubmit(e) {
      e.preventDefault();
      
      this.disableAllFields()
      this.isDisabled = true
      this.feedback = {
        variant: 'info', 
        message: 'Bezig met inloggen...'
      }
      
      login({
        email:    this.fieldValue('email'), 
        password: this.fieldValue('password')
      })
        .then(() => {
          this.setUser({ authenticatedUser: getUser() })
          this.$router.push({ name: 'home' })
        })
        .catch((err) => {
          this.enableAllFields()
          
          let msg = (err.json &&err.json.error_description) || 
            err.message || err.toString()

          this.isDisabled = false
          if (err && err.status === 400) {
            if (msg === 'Email not confirmed') {
              this.feedback = {
                variant: 'danger', 
                message: 'Uw e-mailadres is nog niet geverifieerd'
              }
            } else {
              this.feedback = {
                variant: 'danger', 
                message: 'Uw inlog gegevens zijn ongeldig'
              }
            }
          } else {
            this.feedback = {
              variant: 'danger', 
              message: 'Onbekende fout. Probeer het later nog eens.'
            }
          }
        })
    },
  }
}
</script>
